export const TESTIMONIAL_SHOW_TABS = ['general'] as const;
export type TestimonialShowTab = (typeof TESTIMONIAL_SHOW_TABS)[number];
export const TESTIMONIAL_DEFAULT_TAB: TestimonialShowTab = 'general';
